import * as z from "zod/v4";

export const putShipmonkIntegration = {
  name: "putShipmonkIntegration" as const,
  input: z.object({
    apiKey: z.string().optional(),
    storeId: z.string(),
    sandboxMode: z.boolean(),
  }),
  output: z.object({}),
};
